<template>
    <div class="shop-content">
        <ph-header>
            <van-icon name="arrow-left" size="20px" slot="left" @click="$router.back(-1)" />
        </ph-header>
        <div class="logistics-content">

            <div class="order-info mb24">
                <img :src="EMS.goodLogo" alt="" srcset="">
                <div class="EMS-info">
                    <div class="EMS-company">
                        <span>快递公司</span>
                        <span>{{EMS.company}}</span>
                    </div>
                    <div class="EMS-number">
                        <span>快递单号</span>
                        <span>{{EMS.deliverNum}}</span>
                    </div>
                </div>
            </div>

            <div class="logistics-info">
                <van-skeleton
                    title
                    :row="2"
                    :loading="loading"
                    >
                    <van-steps direction="vertical"
                     :active="0"
                     active-color="#FFD133"
                     v-if="logisticsData">
                        <van-step v-for="(item, index) in logisticsData" :key='index'>
                            <h3>{{item.remark}}</h3>
                            <!-- <h3>{{item.info}}</h3> -->
                            <p>{{item.datetime}}</p>
                        </van-step>

                    </van-steps>
                    <div class="logistics-info_empty fz32 c999" v-else>
                        暂无物流信息
                    </div>
                </van-skeleton>
            </div>

        </div>
    </div>
</template>

<script>
import PhHeader from '@/components/common/Header'
import { Step, Steps } from 'vant'
import { setTimeout } from 'timers'
import { getLogistics } from '@/api/order'
export default {
  name: 'shopLogistics',
  components: {
    PhHeader,
    [Step.name]: Step,
    [Steps.name]: Steps
  },
  data () {
    return {
      active: 1,
      oid: '',
      EMS: {
        company: '',
        deliverNum: ''
      },
      loading: true,
      logisticsData: [

      ]
    }
  },
  computed: {
    token () {
      return this.$store.getters.token
    }
  },
  mounted () {
    this.oid = this.$route.query.oid
    setTimeout(() => { this.loading = false }, 3000)
    this.getLogisticsData()
  },
  methods: {
    getLogisticsData () {
      getLogistics({ soNumber: this.oid, userToken: this.token }).then(res => {
        this.logisticsData = res.detailDTOList
        this.EMS.company = res.company
        this.EMS.deliverNum = res.no
        this.EMS.goodLogo = res.goodLogo
      }).catch(err => {
        this.$toast(err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.order-info{
    display: flex;
    padding: 24px;
    background: #fff;
    img{
        width: 144px;
        height: 144px;
        margin-right: 24px;
    }
    .EMS-info{
        background: #fff;
        font-size: 30px;
        height: 130px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .EMS-company{
            margin-bottom: 24px;
        }
    }
    .EMS-company :last-child{
        margin-left: 20px
    }
    .EMS-number :last-child{
        margin-left:20px
    }
}
.logistics-info{
    background: #fff;
    padding: 24px 0;
    &_empty{
        padding: 0 24px;
        min-height: 300px
    }
}
</style>
